import CommonService from './common.service';

class AuthService extends CommonService {
	async login(params: { [key: string]: string }) {
		return await this.post('login', params);
	}

	async changePassword(params: { [key: string]: string }) {
		return await this.post('change-password', params);
	}

	async forgotPassword(params: { [key: string]: string }) {
		return await this.post('reset-password-email', params)
	}

	async updatePassword(params: { [key: string]: string | null }) {
		return await this.post('update-password', params)
	}

	async getMe() {
		return await this.get('me')
	}

	async editProfile(params: { [key: string]: boolean | string }) {
		return await this.put('profile', params)
	}

}
export const authService = new AuthService();